import {CHOOSE_TYPE} from '../types/Type'

export const typeReducer = (state, action) => {
    switch(action.type){
        case CHOOSE_TYPE:
            return {...state, selectedType: action.payload.select.selectedType}
        default:
        return state;
    }
}